import axios from '../../axios'

export function toursGetLive() {
  return async (dispatch) => {
    try {
      const response = await axios.get('Tours/live')
      dispatch({
        type: 'TOURS_LIVE_FULFILLED',
        payload: {
          response: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'TOURS_LIVE_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function toursGetTodayCount() {
  const todayMidnight = new Date()
  todayMidnight.setHours(0, 0, 0, 0)

  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Tours?filter=${encodeURIComponent(
          JSON.stringify({
            where: {
              and: [
                {
                  firstClocked: {
                    gt: todayMidnight,
                  },
                },
                {
                  or: [{ isReportAvailable: true }, { isVisited: true }],
                },
              ],
            },
            include: 'points',
          })
        )}`
      )

      const tours = response.data
      let tourCounter = 0
      tours.forEach((tour) => {
        if (tour.points.length > 0) {
          tourCounter++
        }
      })
      dispatch({
        type: 'TOURS_TODAY_FULFILLED',
        payload: {
          data: tourCounter,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'TOURS_TODAY_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function toursUpdateRoutes(route) {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_ROUTE_UPDATE',
      payload: {
        response: route,
        error: null,
      },
    })
  }
}
export function toursTrailStart(trackerId) {
  return (dispatch) => {
    dispatch({
      type: 'TRAIL_START',
      payload: {
        data: trackerId,
        error: null,
      },
    })
  }
}
export function toursTrailStop(trackerId) {
  return (dispatch) => {
    dispatch({
      type: 'TRAIL_STOP',
      payload: {
        data: trackerId,
        error: null,
      },
    })
  }
}
export function toursGetHistory(skip, limit) {
  return async (dispatch) => {
    try {
      const response = await axios.get('Tours/history', {
        params: {
          skip: skip,
          limit: limit,
        },
      })
      dispatch({
        type: 'TOURS_HISTORY_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'TOURS_HISTORY_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function toursGetFilteredHistory(skip, limit, filter) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Tours/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`
      )
      dispatch({
        type: 'TOURS_FILTERED_HISTORY_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'TOURS_FILTERED_HISTORY_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function toursGetLog(trackerId) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Trackers/${trackerId}?filter=${encodeURIComponent(
          JSON.stringify({
            include: [
              {
                relation: 'tours',
                scope: {
                  include: [
                    {
                      relation: 'points',
                      scope: {
                        order: 'id ASC',
                      },
                    },
                    {
                      relation: 'checklist',
                      scope: {
                        include: 'pictures',
                      },
                    },
                    {
                      relation: 'reports',
                      scope: {
                        include: [
                          {
                            relation: 'actions',
                            scope: {
                              include: [
                                {
                                  relation: 'remarker',
                                  scope: {
                                    fields: [
                                      'email',
                                      'id',
                                      'name',
                                      'phoneNumber',
                                      'staffId',
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                          {
                            relation: 'pictures',
                          },
                          {
                            relation: 'target',
                            scope: {
                              fields: [
                                'email',
                                'name',
                                'phoneNumber',
                                'staffId',
                              ],
                            },
                          },
                        ],
                        order: 'id ASC',
                      },
                    },
                  ],
                },
              },
              {
                relation: 'routes',
                scope: {
                  order: 'id ASC',
                },
              },
              {
                relation: 'session',
                scope: {
                  include: 'patrollers',
                  fields: [
                    'callerId',
                    'container',
                    'filename',
                    'email',
                    'link',
                    'name',
                    'phoneNumber',
                    'staffId',
                  ],
                },
              },
            ],
            fields: ['id', 'sessionId'],
          })
        )}`
      )

      dispatch({
        type: 'TOURS_LOG_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'TOURS_LOG_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function toursClrLog() {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_LOG_CLEAR',
      payload: {
        data: null,
        error: null,
      },
    })
  }
}
export function toursOnItemsPerPage(count) {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_HISTORY_ITEMPERPAGE',
      payload: {
        count,
      },
    })
  }
}
export function toursOnHistoryCurrentPage(index) {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_HISTORY_CURRPAGE',
      payload: {
        index,
      },
    })
  }
}
export function toursSetDefaultPic(id, idx) {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_SET_PICTURE',
      payload: {
        id: id,
        idx: idx,
      },
    })
  }
}
export function toursGetTypeahead() {
  return async (dispatch) => {
    try {
      const response = await axios.get('Tours/typeahead')
      dispatch({
        type: 'TOURS_TYPEAHEAD_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'TOURS_TYPEAHEAD_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function toursOnHistoryClear() {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_HISTORY_CLEAR',
      payload: null,
    })
  }
}
export function toursGetPrintable(trackerIds) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'TOURS_PRINT_PENDING',
        payload: {
          status: 'pending',
          error: null,
        },
      })
      const response = await axios.get(
        `Trackers?filter=${encodeURIComponent(
          JSON.stringify({
            where: {
              or: trackerIds,
            },
            include: [
              {
                relation: 'tours',
                scope: {
                  include: [
                    {
                      relation: 'points',
                    },
                    {
                      relation: 'reports',
                    },
                  ],
                },
              },
            ],
          })
        )}`
      )
      dispatch({
        type: 'TOURS_PRINT_FULFILLED',
        payload: {
          data: response.data,
          error: null,
          status: 'done',
        },
      })
    } catch (error) {
      dispatch({
        type: 'TOURS_PRINT_REJECTED',
        payload: {
          response: null,
          error: {
            name: error.name,
            message: error.message,
          },
          status: 'done',
        },
      })
    }
  }
}
export function toursClrPrintable() {
  return (dispatch) => {
    dispatch({
      type: 'TOURS_PRINT_PENDING',
      payload: {
        status: 'pending',
        error: null,
      },
    })
  }
}
export function toursGetFullYear() {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'TOURS_STATISTICS_PENDING',
      })
      const response = await axios.get(
        `Tours?filter=${encodeURIComponent(
          JSON.stringify({
            include: {
              relation: 'points',
              scope: {
                order: ['name ASC', 'posTimestamp DESC'],
              },
            },
            order: ['section ASC', 'startTimestamp DESC'],
          })
        )}`
      )
      dispatch({
        type: 'TOURS_STATISTICS_FULFILLED',
        payload: {
          response: response.data,
          error: null,
        },
      })
    } catch (error) {
      dispatch({
        type: 'TOURS_STATISTICS_REJECTED',
        payload: {
          response: null,
          error: {
            name: error.name,
            message: error.message,
          },
        },
      })
    }
  }
}
